import anime from 'animejs';

export function loaderIn(loader) {
    let tl = anime.timeline();

    tl.add({
        targets: loader,
        opacity: 1,
        easing: 'easeInCubic',
        duration: 500
    });
    return tl;
}

export function loaderOut(loader) {
    let tl = anime.timeline();

    tl.add({
        targets: loader,
        opacity: 0,
        easing: 'easeInCubic',
        duration: 500
    });
    return tl;
}

export function fadeIn(node, display = 'block') {
    let tl = anime.timeline();

    node.style.opacity = 0;
    node.style.display = display;

    tl.add({
        targets: node,
        opacity: [0, 1],
        easing: 'easeInSine',
        duration: 650,
        delay: 500
    });

    return tl;
}

export function profileIn(bio, kitList) {
    let tl = anime.timeline();

    tl
        .add({
            targets: bio,
            opacity: [0, 1],
            easing: 'easeInCubic',
            duration: 750,
            begin: function(anim) {
                bio.style.opacity = 0;
                bio.style.display = 'block';
            }
        })
        .add({
            targets: bio,
            easing: 'easeOutQuart',
            translateY: [-20, 0],
            duration: 750,
            offset: 150
        })
        .add({
            targets: kitList,
            opacity: [0, 1],
            easing: 'easeInCubic',
            duration: 900,
            offset: '-=400',
            begin: function(anim) {
                kitList.style.display = 'flex';
            }
        })
        .add({
            targets: kitList,
            translateY: [-20, 0],
            easing: 'easeOutQuart',
            duration: 1500,
            offset: '-=900'
        });

    return tl;
}

export function imageCoverOut(target) {
    let tl = anime.timeline();

    // Prevent animation being called multiple times
    // Probably better to remove the event handler, but this is a lot quicker for now
    target.style.pointerEvents = 'none';

    tl.add({
        targets: target,
        opacity: [1, 0],
        easing: 'easeOutExpo',
        duration: 3000
    });

    return tl;
}

export function dropIn(grid) {
    // grid.style.opacity = 1;
    // grid.style.display = 'flex';

    let tl = anime.timeline({
        targets: '.ProjectGrid__grid__item',
        delay: (el, i) => {
            return i * 150;
        },
        duration: 750,
        easing: 'easeInCubic'
    });

    tl.add({
        opacity: [0, 1]
    });

    return tl;
}

export function menuIn(node) {
    let tl = anime.timeline();

    let appBody = document.getElementsByClassName('App__body__page')[0];
    let appMenu = document.getElementsByClassName('App__mobileMenu')[0];

    appMenu.style.display = 'flex';
    appMenu.style.opacity = 0;

    tl
        .add({
            targets: appMenu,
            opacity: [0, 1],
            easing: 'easeInCubic',
            duration: 350
        })
        .add({
            targets: node,
            opacity: 1,
            easing: 'linear',
            duration: 500,
            delay: 0,
            complete: () => {
                appBody.style.display = 'none';
            }
        });
    return tl;
}

export function menuOut(node) {
    let tl = anime.timeline();

    let appBody = document.getElementsByClassName('App__body__page')[0];
    let appMenu = document.getElementsByClassName('App__mobileMenu')[0];

    appBody.style.display = 'flex';

    tl
        .add({
            targets: node,
            opacity: 0,
            easing: 'easeOutCubic',
            duration: 500
        })
        .add({
            targets: appMenu,
            opacity: [1, 0],
            easing: 'easeInCubic',
            duration: 350,
            complete: function(anim) {
                appMenu.style.display = 'none';
            }
        });

    return tl;
}



// WEBPACK FOOTER //
// ./src/components/utils/animation.js